import useWidth from '../../../../../../../../components/Hooks/useWidth';
import { useProductDetailsListWidth } from '../../../../../contexts/ProductDetailsListWidth.context';
import { setOrderInfoSectionMaxWidth } from '../../../../../utils/productDetailsV2.utils';
import {
  COMBINATION_GRID_ACTIONS_WIDTH,
  COMBINATION_GRID_CELL_WIDTH,
  COMBINATION_GRID_GAP_WIDTH,
  COMBINATION_GRID_MIN_VISIBLE_CELLS,
  COMBINATION_INFO_SECTION_MIN_WIDTH,
  COMBINATION_PRICE_GAP_WIDTH,
  COMBINATION_PRICE_SECTION_WIDTH,
} from '../../../consts/combinationLine.consts';

interface UseCombinationLineDesktopLayoutParams {
  gridLength: number;
  infoSectionWidth?: number;
}

const getGridWidth = (cells: number) =>
  cells * COMBINATION_GRID_CELL_WIDTH + COMBINATION_GRID_ACTIONS_WIDTH;

const getGridMinWidth = ({ lineWidth, gridLength }: { lineWidth: number; gridLength: number }) => {
  const availableWidth =
    lineWidth -
    COMBINATION_PRICE_SECTION_WIDTH -
    COMBINATION_PRICE_GAP_WIDTH -
    COMBINATION_GRID_GAP_WIDTH;

  if (availableWidth <= 0) {
    return 0;
  }

  const floorWidth = Math.min(getGridWidth(COMBINATION_GRID_MIN_VISIBLE_CELLS), availableWidth);
  const widthLeftByInfoSection = availableWidth - COMBINATION_INFO_SECTION_MIN_WIDTH;

  return Math.min(getGridWidth(gridLength), Math.max(floorWidth, widthLeftByInfoSection));
};

const useCombinationLineDesktopLayout = ({
  gridLength,
  infoSectionWidth,
}: UseCombinationLineDesktopLayoutParams) => {
  const { activeBreakpoint } = useWidth();
  const lineWidth = useProductDetailsListWidth();

  const defaultInfoSectionWidth = setOrderInfoSectionMaxWidth({
    activeBreakpoint,
    horizontalTabletWidth: false,
    gridQuantity: gridLength,
  });

  return {
    infoWidth: infoSectionWidth ?? defaultInfoSectionWidth.width,
    infoMaxWidth: infoSectionWidth ?? defaultInfoSectionWidth.maxWidth,
    gridMinWidth: lineWidth > 0 ? getGridMinWidth({ lineWidth, gridLength }) : 0,
  };
};

export default useCombinationLineDesktopLayout;
